// @ts-nocheck
import { AbstractSerializer } from '../../../common/AbstractSerializer';

export default class InfoSerializer extends AbstractSerializer {
    version = 6;

    constructor() {
        super();
    }

    async read(_reader, _layer) {
        // const HeaderClass = sm.mapClassToSerializer.get(Header);
        // const serializerInstance = new HeaderClass();
        // const header = serializerInstance.read(reader);
        // Body
        // const resultId = reader.readUInt8();
        // layer.status.segments.FRAME_MAX = reader.readUInt8();
        // // Also update the min-/max-values here:
        // for (let f = 0; f < layer.status.segments.FRAME_MAX; f++) {
        //     //Maybe refactor with a layer.getFrame that creates the frame if it is null
        // 	const actualFrame = layer.getFrameCollection()[f] == null  ? new Frame(layer) : layer.getFrameCollection()[f] ;
        //     // Create new frame:
        //     const frameName = reader.readString();
        //     actualFrame.name = frameName;	// read and discard (should be the same as with the other files?
        //     let scalarValues = [];
        //     let vectorialValues = [];
        //     for (let N = 0; N < Grid.sensorPointsN; N++) {
        //         const scalarValue = reader.readFloat32();
        //         const vectorialValue = reader.readVec3();
        //         scalarValues[N] = scalarValue != Infinity ? scalarValue : 0;
        //         vectorialValues[N] = vectorialValue;
        //         if (layer.MIN_VALUE > scalarValue)
        // 			layer.setMinVal(scalarValue);
        // 		if (layer.maxValue < scalarValue)
        // 			layer.setMaxValue(scalarValue);
        //     }
        //     actualFrame.setSensorPointValues( scalarValues, vectorialValues);
        //     layer.getFrameCollection()[f] = actualFrame;
        // }
        // setMinMaxValues([layer.MIN_VALUE, layer.MAX_VALUE, 0.0]);
    }
}
